var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 3.49676 3.46152)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 3.49676 24.2311)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 3.49676 45.0006)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 3.49676 65.7691)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 3.49676 86.5382)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 24.4767 3.46152)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 24.4767 24.2311)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 24.4767 45.0006)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 24.4767 65.7691)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 24.4767 86.5382)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 45.4538 3.46152)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 45.4538 24.2311)",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 45.4538 45.0006)",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 45.4538 65.7691)",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 45.4538 86.5382)",
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 66.4328 3.46152)",
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 66.4328 24.2311)",
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 66.4328 45.0006)",
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 66.4328 65.7691)",
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 66.4328 86.5382)",
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 87.4108 3.46152)",
    fill: "white"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 87.4108 24.2311)",
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 87.4108 45.0006)",
    fill: "white"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 87.4108 65.7691)",
    fill: "white"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.4964,
    ry: 3.46152,
    transform: "matrix(-1 0 0 1 87.4108 86.5382)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.0f8de96c7e99e0398a5c345755107199.svg";
export { ForwardRef as ReactComponent };